export const environment = {
  appRoot: '',
  production: true,
  googleApiKey: '?key=AIzaSyC8Mg-7OJKri3Hvcy2oirS_vXT0mWrXAws'
};
